<script>
  import { wasmLoaded } from "../editor/storage";
  import { openSystemTooltip, closeSystemTooltip } from "../editor/utility.js";
  let loading =
    "To run the recommender, both Clingo-WASM and Pyodide must be loaded successfully.";
  let issue =
    "This public demo is rebuilt using WASM for Clingo and Python. There might be untested issues from this integration.";
</script>

<div id="status-marker">
  <!-- todo: tooltip -->
  <div style="display: inline;"
    on:mouseover={function (event) {
      openSystemTooltip(event, loading);
    }}
    on:mousemove={function (event) {
      openSystemTooltip(event, loading);
    }}
    on:focus={() => closeSystemTooltip()}
    on:blur={() => closeSystemTooltip()}
    on:mouseout={() => closeSystemTooltip()}
  >
    <span class="name">Clingo-WASM: </span>
    {#if $wasmLoaded.clingo}
      <span class="ready"><i class="bi bi-circle-fill green" /> Ready</span>
    {:else}
      <span class="loading"><i class="bi bi-x-circle-fill red" /> Loading</span>
    {/if}
    <span class="name ms-3">Pyodide: </span>
    {#if $wasmLoaded.pyodide}
      <span class="ready"><i class="bi bi-circle-fill green" /> Ready</span>
    {:else}
      <span class="loading"><i class="bi bi-x-circle-fill red" /> Loading</span>
    {/if}
  </div>
  <span class="ms-3">
    <a href="https://github.com/see-mike-out/dupo-public" target="_blank"
      ><i class="bi bi-github me-1" /> GitHub</a
    >
  </span>
  <span
    class="ms-3"
    on:mouseover={function (event) {
      openSystemTooltip(event, issue);
    }}
    on:mousemove={function (event) {
      openSystemTooltip(event, issue);
    }}
    on:focus={() => closeSystemTooltip()}
    on:blur={() => closeSystemTooltip()}
    on:mouseout={() => closeSystemTooltip()}
  >
    See an error? Report an <a
      href="https://github.com/see-mike-out/dupo-public/issues"
      target="_blank">issue</a
    >!
  </span>
  <span class="ms-3">
    <a
      href="https://see-mike-out.github.io/dupo-supplementary/manual/index.html"
      target="_blank"><i class="bi bi-book me-1" /> User Manual</a
    >
  </span>
  <span class="ms-5">
    Made by <a href="https://hyeok.me" target="_blank">Hyeok Kim</a>
  </span>
</div>

<style>
  #status-marker {
    margin-left: 0.5rem;
    width: auto;
    font-size: 0.8rem;
    padding-top: 0.15rem;
  }
  .name {
    color: #454545;
  }
  .ready,
  .loading {
    color: #666666;
  }
  .green {
    color: green;
  }
  .red {
    color: red;
  }
  a {
    color: #454545;
    text-decoration: none;
  }
</style>
